import { createContext } from 'react';

/**
 * The app shell's "reading" state on phones. The visible ChatView tucks the
 * shell's top bar away (and condenses the AI disclosure to one line) while a
 * conversation is being read, and brings it back on a scroll up. AppShell
 * owns the state and resets it on every view change.
 */
export const ShellChrome = createContext({ tucked: false, setTucked: () => {} });
